import { TrackedSecondaryButtonLink } from 'components/Button';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { CmsApiRecentSalariesBlockData } from 'modules/cms/api/types/blocks/CmsApiRecentSalariesBlock';
import {
  RecentSubmissionsContainer,
  RecentSubmissionsHeading,
  RecentSubmissionsWrapper,
} from 'modules/salaries/components/RecentSubmissions/RecentSubmissions.styled';

type Props = {
  data: CmsApiRecentSalariesBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsAmpRecentSalariesBlock({
  data: { headline, buttonText, buttonUrl },
  blockIndex,
  pageUpdated,
}: Props) {
  return (
    <RecentSubmissionsContainer>
      <RecentSubmissionsWrapper>
        <RecentSubmissionsHeading>
          <RichTextHeadline>{headline}</RichTextHeadline>
          <TrackedSecondaryButtonLink
            href={buttonUrl}
            $reverse
            eventName="CMS Block"
            eventProperties={{
              block_position: blockIndex,
              block_type: 'Recent Salaries',
              cta_type: 'Button',
              button_text: buttonText,
              page_updated: pageUpdated,
            }}
          >
            {buttonText}
          </TrackedSecondaryButtonLink>
        </RecentSubmissionsHeading>
      </RecentSubmissionsWrapper>
    </RecentSubmissionsContainer>
  );
}
